import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../constants";

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Self-service promo code widget.
 * Props:
 *   onLifetimeGranted: () => void — called when the user is flipped to lifetime
 */
export default function RedeemCodeWidget({ onLifetimeGranted, initialCode = "" }) {
  const [code, setCode] = useState(initialCode);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (initialCode) setCode(initialCode);
  }, [initialCode]);

  const redeem = async () => {
    if (!code.trim()) return;
    setLoading(true);
    try {
      const res = await axios.post(
        `${API}/auth/redeem-code`,
        { code: code.trim() },
        { withCredentials: true, headers: authHeaders() }
      );
      toast.success(res.data.message);
      setCode("");
      if (res.data.granted_lifetime) {
        onLifetimeGranted && onLifetimeGranted();
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to redeem");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card-glass p-5" data-testid="redeem-code-widget">
      <div className="flex items-center gap-2 mb-2">
        <svg className="w-4 h-4 text-[#A3E635]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
        </svg>
        <h3 className="font-heading text-white font-semibold">Have a promo code?</h3>
      </div>
      <p className="text-[#E8E4DC] text-xs mb-3">
        Redeem a free-lifetime or discount code. Partial codes apply at checkout; free codes flip your account instantly.
      </p>
      <div className="flex gap-2">
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && redeem()}
          className="input-dark flex-1"
          placeholder="Enter code"
          data-testid="redeem-code-input"
        />
        <button
          onClick={redeem}
          disabled={loading || !code.trim()}
          className="btn-primary px-5 disabled:opacity-50"
          data-testid="redeem-code-submit"
        >
          {loading ? "…" : "Redeem"}
        </button>
      </div>
    </div>
  );
}
